/*
 * Created by: cparaschiv
 * Date: 18.12.2012, 17:22
 */

TS.viewModel.MessageType = {
    Information: 0,
	Warning: 1,
    Error: 2
};